// @flow
/* istanbul ignore file */
export const OIDC_LOG_LEVEL = window.sharedHeader.REACT_APP_OIDC_LOG_LEVEL;
export const BASE_URL = window.sharedHeader.REACT_APP_BASE_URL;
export const BFF_URL = window.sharedHeader.REACT_APP_BFF_URL;
export const IDS_URL = window.sharedHeader.REACT_APP_IDS_URL;
export const IDS_CLIENT_URL = window.sharedHeader.REACT_APP_IDS_CLIENT_URL;
export const IDS_CLIENT_ID = window.sharedHeader.REACT_APP_IDS_CLIENT_ID;
export const IDS_TOKEN_AUDIENCE = window.sharedHeader.REACT_APP_IDS_TOKEN_AUDIENCE;
export const AUTH_DOMAIN = window.sharedHeader.REACT_APP_AUTH_DOMAIN;
export const ANALYTICS_SCRIPT = window.sharedHeader.REACT_APP_ANALYTICS_SCRIPT;
export const ANALYTICS_ACCOUNT = window.sharedHeader.REACT_APP_ANALYTICS_ACCOUNT;
export const ANALYTICS_URL = window.sharedHeader.REACT_APP_ANALYTICS_URL;
export const LIVE_AGENT_SCRIPT_URL = window.sharedHeader.REACT_APP_LIVE_AGENT_SCRIPT_URL;
export const LIVE_AGENT_CHAT_URL = window.sharedHeader.REACT_APP_LIVE_AGENT_CHAT_URL;
export const LIVE_AGENT_CHAT_ID = window.sharedHeader.REACT_APP_LIVE_AGENT_CHAT_ID;
export const LIVE_AGENT_DEPLOYMENT_ID = window.sharedHeader.REACT_APP_LIVE_AGENT_DEPLOYMENT_ID;
export const LIVE_AGENT_ORGANISATION_ID = window.sharedHeader.REACT_APP_LIVE_AGENT_ORGANISATION_ID;
export const LIVE_AGENT_OFFLINE_EMAIL = window.sharedHeader.REACT_APP_LIVE_AGENT_OFFLINE_EMAIL;
export const LIVE_AGENT_CHINA_CHAT_URL = window.sharedHeader.REACT_APP_LIVE_AGENT_CHINA_CHAT_URL;
export const LIVE_AGENT_CHINA_CHAT_ID = window.sharedHeader.REACT_APP_LIVE_AGENT_CHINA_CHAT_ID;
export const LIVE_AGENT_CHINA_DEPLOYMENT_ID = window.sharedHeader.REACT_APP_LIVE_AGENT_CHINA_DEPLOYMENT_ID;
export const LIVE_AGENT_CHINA_ORGANISATION_ID = window.sharedHeader.REACT_APP_LIVE_AGENT_CHINA_ORGANISATION_ID;
export const LIVE_AGENT_CHINA_OFFLINE_EMAIL = window.sharedHeader.REACT_APP_LIVE_AGENT_CHINA_OFFLINE_EMAIL;
export const LOGGING_CONSOLE_CAPTURE_REG_EXP = window.sharedHeader.REACT_APP_LOGGING_CONSOLE_CAPTURE_REG_EXP;
export const SEARCH_URL = window.sharedHeader.REACT_APP_SEARCH_URL;
export const NEWS_URL = window.sharedHeader.REACT_APP_NEWS_URL;
export const HOMEPAGE_V1_URL = window.sharedHeader.REACT_APP_HOMEPAGE_V1_URL;
export const HOMEPAGE_V2_URL = window.sharedHeader.REACT_APP_HOMEPAGE_V2_URL;
export const WALKME_URL = window.sharedHeader.REACT_APP_WALKME_URL;
export const WALKME_WAIT_TIME = window.sharedHeader.REACT_APP_WALKME_WAIT_TIME || "6000";
export const ACTIVITY_FEED_URL = window.sharedHeader.REACT_APP_ACTIVITY_FEED_URL;
export const INTELLIGENCE_PAGES_NAV_URL = window.sharedHeader.REACT_APP_INTELLIGENCE_PAGES_NAV_URL;
export const COMMODITIES_NAV_URL = window.sharedHeader.REACT_APP_COMMODITIES_NAV_URL;
export const ACTIVITY_FEED_BFF = window.sharedHeader.REACT_APP_ACTIVITY_FEED_BFF;
export const OUTAGE_RETRY_INTERVAL = window.sharedHeader.REACT_APP_OUTAGE_RETRY_INTERVAL || "20";
